import { touchWebClient } from 'tradera/utils/http';

const sendSessionStart = () => {
    touchWebClient.post('/selling/api/scribe/session-start');
};

const sendSessionDuration = (duration, madeByTemplate) => {
    touchWebClient.post('/selling/api/scribe/session-duration', {
        durationMilliSeconds: duration,
        madeByTemplate: madeByTemplate
    });
};

const sendDuration = (measuredName, durationMilliSeconds) => {
    touchWebClient.post('/selling/api/scribe/duration', {
        measuredName: measuredName,
        durationMilliSeconds: durationMilliSeconds
    });
};

const sendIncrement = (name) => {
    touchWebClient.post('/selling/api/scribe/increment', {
        name: name
    });
};

const sendValidationErrors = (errors) => {
    touchWebClient.post('/selling/api/scribe/form-validation-errors', {
        errors: errors
    });
};

export default {
    sendSessionStart,
    sendSessionDuration,
    sendDuration,
    sendIncrement,
    sendValidationErrors
};
